/* eslint-disable react/prop-types */

import { useState, useEffect, useMemo } from "react";
import { useHistory, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import moment from "moment";
import _ from "lodash";

import Card from "@mui/material/Card";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import config from "configs";
import { PostType } from "api";

function PostTypeList({ mode }) {
  const history = useHistory();
  const { t } = useTranslation();
  const [search, setSearch] = useState("");

  const columns = [
    { Header: t("Post Types"), accessor: "name", width: "40%" },
    { Header: t("Slug"), accessor: "slug" },
    { Header: t("No. of Posts"), accessor: "postCount" },
    { Header: t("Created On"), accessor: "createdAt" },
    { Header: t("Editted On"), accessor: "updatedAt" },
    {
      Header: " ",
      accessor: "id",
      Cell: ({ value }) => {
        return <Link to={"/post-types/edit/" + value}>
          <SuiTypography
            variant="body3"
            opacity={0.75}
          >{t("Edit")}</SuiTypography>
        </Link>
      },
    },
  ];

  const [rawData, setRawData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const tableData = useMemo(() => {
    const data = { columns, rows: [] };

    data.rows = [];
    _.get(rawData, "results", []).forEach((result) => {
      data.rows.push({
        id: result.id,
        name: result.titleSC,
        slug: result.slugSC,
        postCount: result.postCount,
        createdAt: result.createdAt
          ? moment(result.createdAt).format("YYYY-MM-DD hh:mm:ss A")
          : "",
        updatedAt: result.updatedAt
          ? moment(result.updatedAt).format("YYYY-MM-DD hh:mm:ss A")
          : "",
        style: {
          cursor: 'pointer'
        },
      });
    });

    return data;
  }, [rawData]);

  const onCellClick = (row, idx) => {
    if (idx < 5) {
      history.push({
        pathname: `/post-types/${row.original.id}/posts`,
        state: { postType: rawData.results.find(p => p.id === row.original.id) }
      });
    }
  }

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const params = { page, pageSize: config.defaults.PAGE_SIZE };
        if (search) {
          params['keyword'] = search;
        }
        const rsp = await PostType.getAll(params);
        const { data } = rsp;
        setRawData(data);
        const { total, pageSize } = data;
        setPageCount(Math.ceil(total / pageSize));
      } catch (err) {
        console.error(err);
      }
      setIsLoading(false);
    })();
  }, [page, search]);

  return (
    <>
      <Helmet>
        <title>{t("Post Type")}</title>
      </Helmet>
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox my={1.5} width="100%">
          <SuiBox width="100%">
            <Card>
              <SuiBox p={1} lineHeight={1} />
              {isLoading ? (
                <>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </>
              ) : (
                <DataTable
                  pageCount={pageCount}
                  table={tableData}
                  showTotalEntries={false}
                  entriesPerPage={false}
                  isSorted={false}
                  onCellClick={onCellClick}
                  onPageChange={setPage}
                  page={page}
                  canSearch
                  onSearch={setSearch}
                  defaultGlobalFilter={search}
                  createButton={mode === "view" ? undefined : (
                    <SuiButton
                      variant="gradient"
                      color="info"
                      onClick={() => {
                        history.push(`/post-types/new`);
                      }}
                    >
                      {t("New Post Type")}
                    </SuiButton>
                  )}
                />
              )}
            </Card>
          </SuiBox>
        </SuiBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}

export default PostTypeList;
